import React from 'react'
import { useNavigate } from 'react-router-dom';

function ModalBasic({setModalOpen}) {
  const closeModal = () =>{
    setModalOpen(false);
  }

  const navigate = useNavigate();

  return (
    <div className='popup'>
      {/* <button onClick={closeModal} className='close'>닫기</button> */}
      <p className='poptext'>상품이 장바구니에 담겼습니다.</p>
      <button className='pop mx-2' onClick={()=>{navigate('/cart')}}>장바구니 확인</button>
      <button onClick={closeModal} className='mx-2 my-5 pop'>닫기</button>
    </div>
  )
}

export default ModalBasic